import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { SystemButton, SystemTextEditor } from '../library';
import HttpRequest from '../service/httpService'
import { toast } from 'react-toastify';
import { SystemDashboardLayout, SystemPanel } from 'library';
import { getUserId, getUserInfo } from '../service/userService';
import { Button } from '../library/common/BaseControls';
import { TextArea } from '@progress/kendo-react-inputs';
import { useForm } from "react-hook-form";
const ContactIt = () => {

    const [request, setRequest] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [supervisor, setSupervisor] = useState('');
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, getValues, clearErrors } = useForm({});

    const submitForm = async (data, event) => {
        if (data.request.length <= 0 || data.contactNumber.length <= 0) {
            toast.error("Please enter a message along with contact number.");
            return;
        }
        data.user = "";
        data.email = "";
        var userData = getUserInfo();
        if (userData.User) {

            data.name = userData.User.UserName;
            data.email = userData.User.EmailId;
            HttpRequest.post("Report/ContactRequest", data).then((response) => {
                if (response && response.data === true) {
                    event.target.reset();
                    toast.info("Request Submitted Successfully.")
                }
                else {
                    toast.error(response.data);
                }
            });
        }
    }

    return (
        <>
            <div className="DashboardWrapperChild contact-request">
                <div className="contentWrapper">
                    <HeaderDashboard title="Contact IT Department" tagLine="" />
                    <div className="container-fluid mt-80 fieldsetGridAndForm">
                        <SystemPanel label="Contact Request" showAdd={false} showRefresh={false} showArchive={false}>
                            <form className="row NewFormReDesign form-group" onSubmit={handleSubmit(submitForm)}>

                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label labelStart labelFontSize">Contact Number: <span className="requiredAstric"> *</span></label>
                                    <div className="col-md-10">
                                        <input type="text" {...register("contactNumber")}></input>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label labelStart labelFontSize">Supervisor Name:</label>
                                    <div className="col-md-10">
                                        <input type="text" {...register("supervisor")}></input>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label labelStart labelFontSize">Message (Max 1000 characters): <span className="requiredAstric"> *</span></label>
                                    <div className="col-md-10">
                                        <textarea  {...register("request")}></textarea>
                                    </div>
                                </div>
                                <button type="submit" style={{ width: "150px" }} className="mt-5 btn btnSave">Submit</button>
                            </form>
                        </SystemPanel>
                    </div>

                </div>
            </div>
        </>
    )
};
export default ContactIt;
